import { Box, colors, Typography } from "@mui/material";
import SubmitButton from "../UI/SubmitButton";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import FileOpenIcon from '@mui/icons-material/FileOpen';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { useTranslation } from "react-i18next";

function DocumentItem({ document }) {
    const { t } = useTranslation();
    const { status, unscheduled } = document;
    const { role } = useSelector(store => store.authorization);

    const monthsArmenian = [
        "Հունվար", "Փետրվար", "Մարտ", "Ապրիլ", "Մայիս", "Հունիս",
        "Հուլիս", "Օգոստոս", "Սեպտեմբեր", "Հոկտեմբեր", "Նոյեմբեր", "Դեկտեմբեր"
    ];

    function formatGetterDate(dateString) {
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.getMonth();
        const monthName = monthsArmenian[month];
        return `${day} ${monthName}`;
    }

    const statusDocs = {
        1: t('page_text.status.created'),
        2: t('page_text.status.edited'),
        3: t('page_text.status.delivery'),
        4: t('page_text.status.archived'),
    }

    // Универсальные стили по ролям и статусам
    const styleMap = {
        1: {
            1: { border: '4px solid rgba(245,166,35,1)' },
            2: { border: '4px solid rgb(0, 17, 255)' },
            3: { border: '4px solid rgb(238, 255, 0)' },
            4: { border: '4px solid rgb(30, 216, 6)' },
        },
        2: {
            1: { border: '4px solid rgba(245,166,35,1)' },
            2: { border: '4px solid rgb(0, 17, 255)' },
            3: { border: '4px solid rgb(238, 255, 0)' },
            4: { border: '4px solid rgb(30, 216, 6)' },
        },
        3: {
            1: { border: '4px solid rgba(245,166,35,1)' },
            2: { border: '4px solid rgb(0, 17, 255)' },
            3: { border: '4px solid rgb(238, 255, 0)' },
            4: { border: '4px solid rgb(30, 216, 6)' },
        },
        4: {
            1: { border: '4px solid rgba(98,255,76,1)' },
            2: { border: '4px solid rgba(245,166,35,1)' },
            3: { border: '4px solid rgba(245,166,35,1)' },
            4: { border: '4px solid rgba(98,255,76,1)' },
        },
        5: {
            1: { border: '4px solid rgba(245,166,35,1)' },
            2: { border: '4px solid rgb(0, 17, 255)' },
            3: { border: '4px solid rgb(238, 255, 0)' },
            4: { border: '4px solid rgb(30, 216, 6)' },
        }
    };

    const declinedStyle = { border: '2px solid rgb(255,2,2)' };

    const getDynamicStyle = () => {
        if (document.isDeclined) return declinedStyle;
        return styleMap?.[role]?.[status] || {};
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '15px',
                gap: 3,
                borderRadius: '16px',
                border: '0.5px solid #f1f1f1',
                ...getDynamicStyle(),
            }}
            key={document.id}
        >

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'center', maxWidth: '200px' }}>
                {unscheduled && <RocketLaunchIcon sx={{ color: 'red' }} />}
                <Typography variant="h6">
                    {formatGetterDate(document.detail_date)}
                </Typography>
                <Typography
                    variant="h7"
                    sx={{
                        width: '80%',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }}
                >
                    {document.branch?.name}
                </Typography>
                <Typography
                    variant="h7"
                    sx={{ color: 'rgb(70, 70, 70)' }}
                >
                    {statusDocs[document.status]}
                </Typography>
            </Box>
            <Link to={`/document/${document.id}`}>
                <SubmitButton endIcon={<FileOpenIcon />}>
                    {t('button.open')}
                </SubmitButton>
            </Link>
        </Box>
    );
}


export default DocumentItem